/**
 * My implementation of trim()
 *
 * By default (passing only the target string as an argument), this function
 * works as the regular trim() function, removing whitespace characters from
 * the beginning and the end of the target string.
 *
 * If, in addition, a string of characters is passed to the "characters" argument,
 * only these characters will be removed from the target string.
 *
 * If a binary flag are set for the options argument, only the corresponding
 * part of the string will be trimmed away.
 *
 * Note that TRIM_BOTH equals ( TRIM_LEFT | TRIM_RIGHT ).
 *
*/
export var trimflags;
(function (trimflags) {
    trimflags[trimflags["TRIM_RIGHT"] = 1] = "TRIM_RIGHT";
    trimflags[trimflags["TRIM_LEFT"] = 2] = "TRIM_LEFT";
    trimflags[trimflags["TRIM_BOTH"] = 3] = "TRIM_BOTH";
})(trimflags || (trimflags = {}));
;
export const trim = (str, characters = " \t\n\r\0\v", options = trimflags.TRIM_BOTH) => {
    if (str === "" || characters === "")
        return str;
    let f = 0, l = str.length - 1; // First and last
    const chrs = new Set(characters.split('')); // The blacklist
    if (options & trimflags.TRIM_LEFT) {
        while (f <= l && chrs.has(str.charAt(f)) && ++f)
            ;
    }
    if (options & trimflags.TRIM_RIGHT) {
        while (l >= f && chrs.has(str.charAt(l)) && --l)
            ;
    }
    return (str.slice(f, l + 1));
};
